import WonderType from "@/roc/wonders/base/WonderType";
import WonderKind from "@/roc/wonders/base/WonderKind";
import WonderOwner from "@/roc/wonders/base/WonderOwner";
import Effects from '@/roc/effects/Effects';
import PassiveAura from '@/roc/effects/PassiveAura/PassiveAura';
import PassiveAuraType from '@/roc/effects/PassiveAura/PassiveAuraType';
import EffectAmount from '@/roc/effects/EffectAmount';
import Synergy from '@/roc/wonders/base/Synergy';
import EraType from '@/roc/era/EraType';

const LeaningTowerOfPisa = {
  id: '65',
  name: 'Leaning Tower of Pisa',
  era: EraType.earlyRome,
  icon: 'top',
  gameId: 'TowerOfPisa',
  minLevel: 1,
  maxLevel: 30,
  type: WonderType.STORIES_AND_MYTHS,
  kind: WonderKind.NATURE | WonderKind.TEMPLE,
  kindMultiplier: 1,
  owner: WonderOwner.CAPITAL,
  effects: Effects.create([
    new PassiveAura(
      PassiveAuraType.RESEARCH_POINT_GENERATION_CAP,
      EffectAmount.asPerLevel([
        15,
        16,
        17,
        18,
        20, // 5
        21,
        22,
        23,
        24,
        25, // 10
        26,
        27,
        28,
        28,
        32, // 15
        33,
        34,
        35,
        36,
        37, // 20
        38,
        39,
        40,
        41,
        42, // 25
        43,
        44,
        45,
        46,
        52  // 30
      ]),
    ),
    new PassiveAura(
      PassiveAuraType.RESEARCH_POINT_GENERATION_TIME_BONUS,
      EffectAmount.asPerLevel([
        10,
        12,
        13,
        15,
        20, // 5
        20,
        21,
        22,
        23,
        23, // 10
        24,
        24,
        25,
        25,
        30, // 15
        30,
        30,
        31,
        31,
        32, // 20
        32,
        32,
        33,
        33,
        33, // 25
        34,
        34,
        34,
        35,
        40  // 30
      ]),
      '%',
    ),
  ]),
  synergies: [
    {
      effectIndex: 1,
      mod: Synergy.asFlat(2.5).withKind(WonderKind.NATURE),
      effect: null,
    }
  ],
};

export default LeaningTowerOfPisa;
